export const DEFAULT_FILTER_OPERATORS = {
  text: [
    {
      text: 'grid.filterContainsOperator',
      operator: 'contains',
    },
  ],
};